export const HP_SETTINGS_FORM_NAME = 'homepageSettings';


// WEBPACK FOOTER //
// ./src/modules/HomepageSettings/constants.js